export default __webpack_public_path__ + "static/media/inbox-image.6e219971.jpg";